export const ASSESSMENT_DATA = {
    a: {
        name: 'Food Quality & Sourcing',
        icon: '🛒',
        questions: [
            'I rely on packaged or ultra-processed meals/snacks.',
            'I use added sugars/syrups in drinks/foods.',
            'I consume “diet/zero” products with artificial sweeteners.',
            'I use refined seed oils (veg/soy/corn/sunflower) for cooking.',
            'I eat fast food or takeaways.',
            'I have desserts/confectionery after dinner.',
            'I eat charred/over-browned foods (e.g., BBQ/blackened meats).',
            'My usual salt is standard table salt (not mineral-rich).',
            'When I buy packaged foods, I read the ingredient list and nutrition label.', // REVERSE CODED
            'I eat fewer than 5 portions of fruit/veg per day.'
        ]
    },
    b: {
        name: 'Meal Rhythm & Composition',
        icon: '🍽️',
        questions: [
            'I skip breakfast.',
            'I go more than ~4 hours without eating and then feel wired, shaky, or over-hungry.',
            'I snack on carbs alone (no protein/fat).',
            'My largest meal is late evening.',
            'I eat quickly and rarely chew thoroughly.',
            'I don’t include a quality protein at each meal.',
            'I don’t include colourful plants at each meal.',
            'I don’t include healthy fats (olive oil, eggs, oily fish, nuts).'
        ]
    },
    c: {
        name: 'Blood Sugar & Cravings',
        icon: '🍬',
        questions: [
            'I get energy dips, shakiness, or brain fog between meals.',
            'I crave sweets or stimulants mid-afternoon/evening.',
            'I feel better briefly after sugary foods/drinks, then crash.',
            'I wake in the night hungry or restless.',
            'I feel irritable (“hangry”) if meals are delayed.',
            'I struggle to lose fat despite “dieting”.',
            'I need caffeine to start the day or keep going.'
        ]
    },
    d: {
        name: 'Digestion & Gut Signals',
        icon: '🌿',
        questions: [
            'Bloating or abdominal discomfort after meals.',
            'Frequent gas or burping.',
            'Heartburn/reflux.',
            'Undigested food visible in stools.',
            'My bowel pattern is inconsistent (constipation vs. loose stools).',
            'I feel sleepy/flat after eating.',
            'I develop strong cravings if I don’t eat certain “trigger” foods (bread, crisps).',
            'I regularly need antacids/digestive aids.',
            'I have skin issues (acne/eczema) that flare after certain foods.'
        ]
    },
    e: {
        name: 'Hydration & Minerals',
        icon: '💧',
        questions: [
            'I drink <1.5–2 L water/herbal fluids per day.',
            'I get cramps, headaches, or light-headedness with exercise/heat.',
            'I frequently wake at night to urinate.',
            'I feel better with saltier foods or adding mineral salt.',
            'I often feel thirsty but still tired/sluggish.',
            'I rarely consume mineral-rich foods (seafood, greens, seeds).'
        ]
    },
    f: {
        name: 'Stimulants & Alcohol',
        icon: '☕',
        questions: [
            'Coffee/energy drinks >2 per day.',
            'Alcohol >7 units/week (women) or >14 units/week (men).',
            'I use alcohol to unwind or to sleep.',
            'Caffeine late afternoon/evening.',
            'I feel worse the next day after modest drinking (sleep/energy/HRV).'
        ]
    },
    g: {
        name: 'Macro Consistency & Satiety',
        icon: '⚖️',
        questions: [
            'I get a noticeable energy crash 1–3 h after a carb-only snack/meal.',
            'A protein-centred breakfast improves my energy/satiety.',
            'Sweet desserts at night disrupt my sleep or next-day energy.',
            'If I skip protein at a meal, I’m hungry again within 2–3 hours.',
            'I feel better when meals include healthy fats.',
            'A carb-only snack leaves me jittery then flat.',
            'When I increase protein, my cravings reduce and evening snacking drops.',
            'When my carbs are higher, I’m hungrier overall and crave more.'
        ]
    },
    h: {
        name: 'Food Reactions & Tolerance',
        icon: '⚠️',
        questions: [
            'I experience delayed symptoms (4–48 h later) after specific foods.',
            'I experience immediate reactions (itching, hives) after specific foods.',
            'When I consume dairy, I notice gut, skin, or sinus symptoms.',
            'When I consume gluten, I notice gut or skin symptoms.',
            'When I consume FODMAP-rich foods (onions, beans), I get bloating/gas.',
            'I feel noticeably better when I eat simple, minimally processed meals.'
        ]
    }
};

export const PILLAR_ORDER = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
export const LABELS = ['No', 'Sometimes', 'Often', 'Most days'];

export const getQuestionScore = (pillarKey, questionIndex, answerValue) => {
    // Reverse Coding for Pillar A, Question Index 8 (9th question)
    if (pillarKey === 'a' && questionIndex === 8) {
        return 3 - answerValue;
    }
    return answerValue;
};
